import { Target, Wind } from "lucide-react";
import { gradeLabel } from "@/lib/api";

const MOOD = ["", "Heavy", "Restless", "Okay", "Calm", "Bright"];

export const ReflectionCard = ({ e, showStudent }) => (
  <article className="rounded-3xl bg-[#F7F3EB] border border-[#E6DEC3] p-6" data-testid={`reflection-card-${e.id}`}>
    <p className="text-xs uppercase tracking-widest text-[#C87D53] font-semibold">
      {showStudent && <span className="text-[#2C4A3E]">{e.student_name} · </span>}{e.subject_name} · {gradeLabel(e.grade)}
    </p>
    <h3 className="font-display text-xl text-[#2C4A3E] mt-1">{e.topic}</h3>
    {e.intention && <p className="text-sm text-stone-500 mt-3 italic">Intention: "{e.intention}"</p>}
    <p className="mt-3 text-stone-700 leading-relaxed whitespace-pre-line">{e.reflection}</p>
    {e.gratitude && <p className="text-sm text-stone-600 mt-3">Grateful for: {e.gratitude}</p>}
    <div className="flex flex-wrap gap-4 mt-5 text-xs text-stone-500">
      <span className="inline-flex items-center gap-1"><Target className="w-3.5 h-3.5" />{e.quiz_score}/{e.quiz_total}</span>
      <span className="inline-flex items-center gap-1"><Wind className="w-3.5 h-3.5" />{e.mindful_minutes} min</span>
      <span>{MOOD[e.mood_before]} → {MOOD[e.mood_after]}</span>
      <span>{new Date(e.created_at).toLocaleString()}</span>
    </div>
  </article>
);
